import { cond, pipe, when, identity, T } from 'ramda';
import cameraStatus from './communication/cameraStatus';
import positionsUpdate from './communication/positionsUpdate';
import registerFeedback from './communication/registerFeedback';
import request from './communication/request';
import response from './communication/response';
import robotRegister from './communication/robotRegister';
import robotStatus from './communication/robotStatus';
import sandboxSpecial from './communication/sandboxSpecial';
import sensorFeedback from './communication/sensorFeedback';
import sensorsUpdate from './communication/sensorsUpdate';
import studentPing from './communication/studentPing';
import variablesSet from './communication/variablesSet';
import variablesUpdate from './communication/variablesUpdate';

/**
 * Payload are validate using JSON Schema.
 *
 * @param {!string} topic - Topic received
 * @param {!Object} payload - Payload object
 * @param {!func} publish - Function used to publish new packets
 * @see https://tools.ietf.org/html/draft-zyp-json-schema-03
 */
export default function processor(topic, payload, publish) {
  const resolve = cond([
    cameraStatus,
    positionsUpdate,
    registerFeedback,
    request,
    response,
    robotRegister,
    robotStatus,
    sandboxSpecial,
    sensorFeedback,
    sensorsUpdate,
    studentPing,
    variablesSet,
    variablesUpdate,
    // eslint-disable-next-line no-console
    [T, m => console.warn('Message failed to pass the schema validation: %o', m)],
  ]);

  const publishIfConditionalResolved = pipe(
    resolve,
    when(identity, publish),
  );

  publishIfConditionalResolved({ topic, payload });
}
